<script>
import BaseButton from '@/js/components/common/buttons/BaseButton';

export default {
    name: 'MoveUpButton',

    functional: true,

    props: {
        type: {type: String, default: 'button'},
        label: {type: String, default: null},
        hideLabel: {type: Boolean},
        isSmall: {type: Boolean},
        isLoading: {type: Boolean},
        disabled: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            label: props.label || parent.$t('common.actions.move-up'),
            iconClass: 'fa fa-arrow-up',
            color: 'btn-outline-secondary',
            isSmall: props.isSmall,
            hideLabel: props.hideLabel,
            isLoading: props.isLoading,
            disabled: props.disabled,
            type: props.type,
        };

        return createElement(BaseButton, data);
    },
};
</script>
